export default "/static/dataman_70_tiny.png";